import React from 'react';
import sAction from 'sAction';
import {Button} from '@material-ui/core';
import propTypes from 'prop-types';

export default function InactiveCurPopup(props) {
    return (
        <React.Fragment>
            <div className="acmPopupHeader red">
                {sAction.translate('LBL_WARNING', 'Currencies')}
            </div>
            <div className="acmPopupContent">
                <span>
                    {sAction.translate('LBL_INACTIVE_CURR_WARNING', 'Currencies')}
                </span>
            </div>
            <div className="acmPopupButtons" style={{justifyContent: 'flex-end'}}>
                <Button
                    className="MuiButtonBase-root MuiButton-root MuiButton-contained acmButton undefined"
                    onClick={() => sAction.popupHide()}>
                    {sAction.translate('LBL_CONTINUE', 'Home')}
                </Button>
            </div>
        </React.Fragment>
    );
}

InactiveCurPopup.propTypes = {
    data: propTypes.object,
};
